<div class="wrapper">
    <div>
        <label id="switchButton" class="switch">
            <input type="checkbox" [(ngModel)]="invertedIsDisabled" (click)="vm.onClick()">
            <span class="slider round"></span>
        </label>
    </div>
	<div id="switchLabel">{{ vm.label }}</div>
</div>
